import React, { useEffect, useState } from "react";
import MaterialTable, { MTableFilterRow, MTableToolbar } from "material-table";
import { useStyles } from "../../styles/useStyles";
import IssuedCardsDataService from "../../../services/IssuedCardsService";

export default function IssuedCardsTable(props) {
  const classes = useStyles();

  const [issuedCards, setIssuedCards] = useState([]);

  const [loc] = React.useState(
    JSON.parse(localStorage.getItem("loc")).id || ""
  );

  const tableRef = React.createRef();

  useEffect(() => {
    retrieveIssuedCards();
  }, []);

  const retrieveIssuedCards = () => {
    IssuedCardsDataService.getAll()
      .then((response) => {
        setIssuedCards(response.data);
        console.log(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const [columns, setColumns] = useState([
    {
      title: "Стая",
      field: "room",
      emptyValue: (e, rowData) => {
        return "empty";
      },
    },
    {
      title: "Издадена за:",
      field: "t_user.name",
      emptyValue: (e, rowData) => {
        return "empty";
      },
    },
    {
      title: "Дубликат?",
      field: "duplicate",
      emptyValue: (e, rowData) => {
        return "empty";
      },
    },
    {
      title: "Група",
      field: "group",
      emptyValue: (e, rowData) => {
        return "empty";
      },
    },
    {
      title: "Вид карта",
      field: "user_type",
      emptyValue: (e, rowData) => {
        return "empty";
      },
    },
    {
      title: "Издадена на",
      field: "createdAt",
      emptyValue: (e, rowData) => {
        return "empty";
      },
      render: (rowData) => {
        const date = new Date(rowData.end_time);
        return date
          .toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
          })
          .replace(",", " ");
      },
    },
    {
      title: "Валидна до",
      field: "end_time",
      emptyValue: (e, rowData) => {
        return "empty";
      },
      render: (rowData) => {
        const date = new Date(rowData.end_time);
        return date
          .toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
          })
          .replace(",", " ");
      },
    },
    {
      title: "Guest Count",
      field: "guest_count",
      emptyValue: (e, rowData) => {
        return "empty";
      },
      hidden: localStorage.getItem("level") !== "super",
    },
    {
      title: "Employee Count",
      field: "staff_count",
      emptyValue: (e, rowData) => {
        return "empty";
      },
      hidden: localStorage.getItem("level") !== "super",
    },
    {
      title: "Master Count",
      field: "master_count",
      emptyValue: (e, rowData) => {
        return "empty";
      },
      hidden: localStorage.getItem("level") !== "super",
    },
  ]);
  // * Add Filters to State End

  const [components] = useState({
    Toolbar: (props) => (
      <div>
        <MTableToolbar {...props} />
      </div>
    ),
    FilterRow: (props) => <MTableFilterRow {...props} />,
  });

  return (
    <div>
      <MaterialTable
        title="Издадени карти"
        columns={columns}
        data={issuedCards}
        style={{
          borderRadius: "0",
          boxShadow: "none",
        }}
        actions={[
          {
            icon: "refresh",
            tooltip: "Refresh",
            isFreeAction: true,
            onClick: retrieveIssuedCards,
          },
        ]}
        options={{
          loadingType: "linear",
          pageSize: 50,
          maxBodyHeight: "68vh",
          showTitle: false,
          sorting: true,
          actionsColumnIndex: -1,
          exportButton: { csv: true, pdf: false },
          filtering: true,
          pageSizeOptions: [20, 50, 100, 200, 300, 400, 500],
          search: true,
          toolbar: true,
        }}
        components={components}
        localization={{
          pagination: {
            labelDisplayedRows: "{from}-{to} от {count}",
            labelRowsSelect: "Издадени карти",
          },
          header: {
            actions: "Actions",
          },
          body: {
            emptyDataSourceMessage: "Издадени карти...",
            editTooltip: "Редактирай",
            deleteTooltip: "Премахни",
            filterRow: {
              filterTooltip: "Филтър",
            },
            editRow: {
              deleteText: "Сигурни ли сте че искате да изтриете събитието?",
              cancelTooltip: "Отказ",
              saveTooltip: "Запази",
            },
          },
          toolbar: {
            exportTitle: "Експорт",
            exportName: "Експорт към CSV",
            searchTooltip: "Tърси",
            searchPlaceholder: "Tърси",
            nRowsSelected: "{0} реда избрани",
          },
        }}
      />
    </div>
  );
}
